import React, { ReactNode } from 'react';
import { SecurityContextTemplate } from 'framework/authorization';
import useCrmStrategyNoteService from './crmStrategyNoteService';

const CRM_STRATEGY_NOTE_CONTEXT = 'CrmStrategyNote';

const StrategyNoteContext = ({ id, children }: { id: StringOrNumber; children: ReactNode }) => {
  const { getPermissions } = useCrmStrategyNoteService();

  return (
    <SecurityContextTemplate id={id} getPermissionsFunc={getPermissions} contextName={CRM_STRATEGY_NOTE_CONTEXT}>
      {children}
    </SecurityContextTemplate>
  );
};

export default StrategyNoteContext;
